import { defineStore } from 'pinia';

export const useSunmiStore = defineStore('sunmi', {
	state: () => ({
		printers: [],
		printerWifis: [],
		successfullConnection: false,
		failedConnection: false,
		fiscalPrinterResult: null,
		failedTapPhoneConnection: false,
		successTapPhoneConnection: false,
		failedTapPhonePayment: false,
		bluetoothUpdateProgress: null,
	}),
	getters: {

	},
	actions: {

	}
});
